import { useEffect, useSyncExternalStore } from 'react';

/**
 * Whether something must not be interrupted: a take being recorded, or practice or rehearsal
 * playback. The maintenance notice waits until nothing is busy, so a deploy never cuts a take off.
 */
const busy = new Set<symbol>();
const listeners = new Set<() => void>();

function emit() {
  for (const listener of listeners) listener();
}

/** Marks this component busy while `active` is true. */
export function useBusy(active: boolean): void {
  useEffect(() => {
    if (!active) return;
    const key = Symbol('busy');
    busy.add(key);
    emit();
    return () => {
      busy.delete(key);
      emit();
    };
  }, [active]);
}

export function useIsBusy(): boolean {
  return useSyncExternalStore(
    (listener) => {
      listeners.add(listener);
      return () => listeners.delete(listener);
    },
    () => busy.size > 0,
  );
}
